import { Component, OnInit, Input } from '@angular/core';
import { BaseService } from './../../_services/base.service';
import {Observable} from 'rxjs/Rx';
import { ActivatedRoute } from '@angular/router';
import { Adal5Service } from 'adal-angular5';
@Component({
  selector: 'app-map-tile',
  templateUrl: './map-tile.component.html',
  styleUrls: ['./map-tile.component.scss']
})
export class MapTileComponent implements OnInit {
  maps: Promise<any[]>;
  categories: Promise<any[]>; 
  token: any;
  constructor(private baseService: BaseService, private adalService: Adal5Service) {
    this.token = this.adalService.userInfo.token;
   }

  ngOnInit() {
    this.maps = this.baseService.getMapDescriptions(this.token);

  }


}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/components/map-tile/map-tile.component.ts